export default __webpack_public_path__ + "static/media/safari.4e6a7bc8.svg";